import React from 'react'
import { PropTypes } from 'prop-types'
import styles from './errorMsg.module.scss'

const ErrorMessage = ({ message }) => {
  return <span className={`${styles.errMsg} g-error-msg`}>{message}</span>
}

ErrorMessage.propTypes = {
  message: PropTypes.string
}
export default ErrorMessage
